/**
 * Mikori Easy Bundle Builder
 * Mix-and-match bundle engine with tiered discount display.
 */

(function () {
  'use strict';

  const products = window.MIKORI_BUNDLE_PRODUCTS || [];
  const settings = window.MIKORI_BUNDLE_SETTINGS || { currency: 'INR', moneyFormat: '₹{{amount}}' };

  // ── State ────────────────────────────────────────────────────────
  let bundle = []; // [{ variantId, productHandle, qty, price, title, variantTitle, image }]

  // ── DOM refs ─────────────────────────────────────────────────────
  const grid = document.getElementById('mk-bundle-grid');
  const itemsContainer = document.getElementById('mk-bundle-items');
  const totalsContainer = document.getElementById('mk-bundle-totals');
  const subtotalEl = document.getElementById('mk-bundle-subtotal');
  const discountEl = document.getElementById('mk-bundle-discount');
  const totalEl = document.getElementById('mk-bundle-total');
  const badgeEl = document.getElementById('mk-bundle-badge');
  const progressEl = document.getElementById('mk-bundle-progress');
  const addToCartBtn = document.getElementById('mk-bundle-add-to-cart');

  // ── Helpers ──────────────────────────────────────────────────────
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    return settings.moneyFormat.replace(/\{\{\s*amount\s*\}\}/g, value);
  }

  function getProduct(handle) {
    return products.find(p => p.handle === handle);
  }

  function getVariant(productHandle, variantId) {
    const p = getProduct(productHandle);
    return p ? p.variants.find(v => v.id === variantId) : null;
  }

  // ── Discount Logic ───────────────────────────────────────────────
  const GIFT_PRICE_PAISE = settings.giftPricePaise || 0;
  const GIFT_VARIANT_ID = settings.giftVariantId || null;

  function calcDiscount(subtotalPaise, totalQty) {
    let rate = 0;
    if (subtotalPaise >= 200000) rate = 0.20;
    else if (totalQty >= 3) rate = 0.10;
    else if (totalQty >= 2) rate = 0.05;
    return { rate, amount: Math.round(subtotalPaise * rate) };
  }

  function nextTierInfo(subtotalPaise, totalQty) {
    if (subtotalPaise >= 200000) return { msg: '🔥 Maximum savings unlocked!', pct: 100 };
    if (totalQty >= 3) {
      const need = 200000 - subtotalPaise;
      return {
        msg: need > 0 ? `Add ${formatMoney(need)} more for 20% off` : '20% off unlocked!',
        pct: Math.min(100, Math.round((subtotalPaise / 200000) * 100))
      };
    }
    if (totalQty >= 2) {
      return { msg: 'Add 1 more item for 10% off', pct: 66 };
    }
    return { msg: 'Add 1 more item for 5% off', pct: 33 };
  }

  function isGiftActive() {
    const cb = document.getElementById('mk-bundle-gift-toggle');
    return cb && cb.checked;
  }

  // ── State Management ─────────────────────────────────────────────
  function addItem(productHandle, variantId) {
    const existing = bundle.find(i => i.variantId === variantId);
    if (existing) {
      existing.qty++;
    } else {
      const p = getProduct(productHandle);
      const v = getVariant(productHandle, variantId);
      if (!p || !v) return;
      bundle.push({
        variantId: v.id,
        productHandle: p.handle,
        qty: 1,
        price: v.price,
        title: p.title,
        variantTitle: v.title,
        image: p.image
      });
    }
    updateUI();
  }

  function removeItem(variantId) {
    bundle = bundle.filter(i => i.variantId !== variantId);
    updateUI();
  }

  function setQty(variantId, qty) {
    const item = bundle.find(i => i.variantId === variantId);
    if (!item) return;
    if (qty < 1) {
      removeItem(variantId);
      return;
    }
    item.qty = qty;
    updateUI();
  }

  function clearBundle() {
    bundle = [];
    updateUI();
  }

  // ── UI Rendering ─────────────────────────────────────────────────
  function updateUI() {
    // Update product cards
    $$('.mk-bundle-card').forEach(card => {
      const handle = card.dataset.product;
      const select = card.querySelector('[data-variant-select]');
      const variantId = parseInt(select.value, 10);
      const inBundle = bundle.some(i => i.variantId === variantId);
      const btn = card.querySelector('[data-add-btn]');
      card.classList.toggle('is-selected', inBundle);
      if (btn) btn.textContent = inBundle ? 'Added' : 'Add to Bundle';
    });

    // Update sidebar
    if (bundle.length === 0) {
      itemsContainer.innerHTML = '<div class="mk-bundle-summary__empty">Select products to start building your bundle</div>';
      totalsContainer.style.display = 'none';
      return;
    }

    totalsContainer.style.display = 'block';

    // Render items
    itemsContainer.innerHTML = bundle.map(item => `
      <div class="mk-bundle-item" data-variant="${item.variantId}">
        <div class="mk-bundle-item__img" style="background-image:url('${item.image || ''}')"></div>
        <div class="mk-bundle-item__info">
          <div class="mk-bundle-item__name">${escapeHtml(item.title)}</div>
          ${item.variantTitle && item.variantTitle !== 'Default Title' ? `<div class="mk-bundle-item__variant">${escapeHtml(item.variantTitle)}</div>` : ''}
        </div>
        <button class="mk-bundle-item__remove" data-remove="${item.variantId}" aria-label="Remove ${escapeHtml(item.title)}">×</button>
        <div class="mk-bundle-item__controls">
          <div class="mk-bundle-item__qty">
            <button data-decr="${item.variantId}" aria-label="Decrease quantity">−</button>
            <span>${item.qty}</span>
            <button data-incr="${item.variantId}" aria-label="Increase quantity">+</button>
          </div>
          <div class="mk-bundle-item__line">${formatMoney(item.price * item.qty)}</div>
        </div>
      </div>
    `).join('');

    // Calculate totals
    const subtotal = bundle.reduce((sum, i) => sum + (i.price * i.qty), 0);
    const totalQty = bundle.reduce((sum, i) => sum + i.qty, 0);
    const discount = calcDiscount(subtotal, totalQty);
    const giftActive = isGiftActive();
    const giftCost = giftActive ? GIFT_PRICE_PAISE : 0;
    const total = subtotal - discount.amount + giftCost;

    subtotalEl.textContent = formatMoney(subtotal);
    discountEl.textContent = discount.rate > 0 ? `−${formatMoney(discount.amount)}` : '−';
    totalEl.textContent = formatMoney(total);

    // Gift row
    const giftRow = document.getElementById('mk-bundle-gift-row');
    if (giftRow) giftRow.style.display = giftActive ? 'flex' : 'none';
    const giftCard = document.getElementById('mk-bundle-gift');
    if (giftCard) giftCard.classList.toggle('is-active', giftActive);

    // Badge
    if (discount.rate > 0) {
      badgeEl.classList.remove('is-locked');
      badgeEl.innerHTML = `🎉 ${Math.round(discount.rate * 100)}% bundle discount applied`;
    } else {
      badgeEl.classList.add('is-locked');
      badgeEl.textContent = 'Add 2+ items to unlock savings';
    }

    // Progress
    const next = nextTierInfo(subtotal, totalQty);
    if (progressEl) {
      progressEl.innerHTML = `
        <div class="mk-bundle-progress__label">${next.msg}</div>
        <div class="mk-bundle-progress__bar"><div class="mk-bundle-progress__fill" style="width:${next.pct}%"></div></div>
      `;
    }

    // Sticky bar
    const stickyBar = document.getElementById('mk-bundle-stickybar');
    const stickyCount = document.getElementById('mk-bundle-stickybar-count');
    const stickyTotal = document.getElementById('mk-bundle-stickybar-total');
    if (stickyBar && stickyCount && stickyTotal) {
      if (bundle.length > 0) {
        stickyBar.classList.add('is-visible');
        stickyBar.setAttribute('aria-hidden', 'false');
        stickyCount.textContent = totalQty + (totalQty === 1 ? ' item' : ' items') + (giftActive ? ' + gift' : '');
        stickyTotal.textContent = formatMoney(total);
      } else {
        stickyBar.classList.remove('is-visible');
        stickyBar.setAttribute('aria-hidden', 'true');
      }
    }

    // Wire qty buttons
    $$('[data-decr]').forEach(btn => {
      btn.addEventListener('click', () => {
        const id = parseInt(btn.dataset.decr, 10);
        const item = bundle.find(i => i.variantId === id);
        if (item) setQty(id, item.qty - 1);
      });
    });
    $$('[data-incr]').forEach(btn => {
      btn.addEventListener('click', () => {
        const id = parseInt(btn.dataset.incr, 10);
        const item = bundle.find(i => i.variantId === id);
        if (item) setQty(id, item.qty + 1);
      });
    });
    $$('[data-remove]').forEach(btn => {
      btn.addEventListener('click', () => removeItem(parseInt(btn.dataset.remove, 10)));
    });
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  // ── Event Listeners ──────────────────────────────────────────────
  if (grid) {
    grid.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-add-btn]');
      if (!btn) return;
      const card = btn.closest('.mk-bundle-card');
      const handle = card.dataset.product;
      const select = card.querySelector('[data-variant-select]');
      const variantId = parseInt(select.value, 10);
      const inBundle = bundle.some(i => i.variantId === variantId);
      if (inBundle) {
        // Toggle off
        removeItem(variantId);
      } else {
        addItem(handle, variantId);
      }
    });

    grid.addEventListener('change', (e) => {
      const select = e.target.closest('[data-variant-select]');
      if (!select) return;
      const card = select.closest('.mk-bundle-card');
      const priceEl = card.querySelector('.mk-bundle-card__price');
      const opt = select.options[select.selectedIndex];
      const price = parseInt(opt.dataset.price, 10);
      if (priceEl && !isNaN(price)) {
        priceEl.textContent = formatMoney(price);
        priceEl.dataset.price = price;
      }
      // Update card selection state for new variant
      const variantId = parseInt(select.value, 10);
      const inBundle = bundle.some(i => i.variantId === variantId);
      const btn = card.querySelector('[data-add-btn]');
      card.classList.toggle('is-selected', inBundle);
      if (btn) btn.textContent = inBundle ? 'Added' : 'Add to Bundle';
    });
  }

  // ── Add Bundle to Cart ───────────────────────────────────────────
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', async () => {
      if (bundle.length === 0) return;

      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Adding...';

      const bundleId = 'bundle-' + Date.now() + '-' + Math.random().toString(36).slice(2, 6);
      const subtotal = bundle.reduce((sum, i) => sum + (i.price * i.qty), 0);
      const totalQty = bundle.reduce((sum, i) => sum + i.qty, 0);
      const tierPct = Math.round(calcDiscount(subtotal, totalQty).rate * 100);
      const sections = ['cart-drawer', 'cart-icon-bubble'];

      // Always use the .js endpoint so Shopify returns JSON, not the HTML cart page.
      const baseAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      const endpoint = baseAddUrl.endsWith('.js') ? baseAddUrl : baseAddUrl + '.js';

      try {
        const res = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: (function(){
              const arr = bundle.map(item => ({
                id: item.variantId,
                quantity: item.qty,
                properties: {
                  _bundle_id: bundleId,
                  _bundle_tier_pct: tierPct
                }
              }));
              if (isGiftActive() && GIFT_VARIANT_ID) {
                arr.push({
                  id: GIFT_VARIANT_ID,
                  quantity: 1,
                  properties: {
                    _bundle_id: bundleId,
                    _gift_box: 'true'
                  }
                });
              }
              return arr;
            })(),
            sections: sections.join(','),
            sections_url: window.location.pathname
          })
        });

        const data = await res.json();
        if (!res.ok || data.status) {
          throw new Error(data.description || data.message || ('Cart returned ' + res.status));
        }

        clearBundle();

        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          drawer.renderContents(data);
          drawer.open();
        }

        if (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          document.dispatchEvent(new CustomEvent(window.PUB_SUB_EVENTS.cartUpdate));
        }

        const discountCode = window.MIKORI_BUNDLE_SETTINGS && window.MIKORI_BUNDLE_SETTINGS.discountCodes
          && window.MIKORI_BUNDLE_SETTINGS.discountCodes['t' + tierPct];
        if (tierPct > 0 && discountCode) {
          window.location.href = '/discount/' + encodeURIComponent(discountCode) + '?redirect=/cart';
        }

      } catch (err) {
        alert('Could not add bundle to cart: ' + err.message);
      } finally {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'Add Bundle to Cart';
      }
    });
  }

  // ── Gift toggle listener ─────────────────────────────────────────
  (function() {
    const giftToggle = document.getElementById('mk-bundle-gift-toggle');
    if (giftToggle) {
      giftToggle.addEventListener('change', updateUI);
    }
  })();

  // ── URL Pre-fill ─────────────────────────────────────────────────
  (function prefillFromURL() {
    const params = new URLSearchParams(window.location.search);
    const product = params.get('product');
    const qty = parseInt(params.get('qty'), 10) || 1;
    if (product) {
      const p = getProduct(product);
      if (p && p.variants.length > 0) {
        addItem(p.handle, p.variants[0].id);
        if (qty > 1) {
          const item = bundle.find(i => i.variantId === p.variants[0].id);
          if (item) item.qty = qty;
          updateUI();
        }
      }
    }
  })();
})();
